// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewCardsWrapper_wrapper__b43cV"};